<template>
    <a-modal
            :title="`共享小组`"
            centered
            :width="640"
            :mask-closable="false"
            :visible="showSharedForm"
            :confirmLoading="loading"
            @cancel="close"
    >
        <a-form-model
                ref="form"
                :model="model"
                :rules="rules"
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
        >
            <a-spin :spinning="loading">
                <a-form-model-item label="所属小组" prop="team_ids">
                    <a-select placeholder="请选择" :default-value="model.team_ids" mode="multiple" show-search allow-clear option-filter-prop="children"
                              v-model="model.team_ids">
                        <a-select-option :value="item.id" v-for="item in teams" :key="item.id">
                            {{ item.name }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-spin>
        </a-form-model>

        <template slot="footer">
            <a-button @click="close" :disabled="loading">取消</a-button>
            <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
        </template>
    </a-modal>
</template>

<style lang="less" scoped>
@import 'Shared';
</style>

<script>
import Shared from './Shared'

export default Shared
</script>
